<template>
  <div class="filter pdtb12">
    <!-- <div class="flex align-center mgb12">
      <div>橱窗分类：</div>
      <div class="text-pointer text-orange">
        全部
      </div>
    </div> -->
    <div class="flex align-center pdb12">
      <div>最近上新：</div>
      <div
        v-for="item in dayOptions"
        :key="item.value"
        class="text-pointer mgr12"
        :class="filterParams.newPutTime === item.value ? 'text-orange' : ''"
        @click="chooseFilter(item)"
      >
        {{ item.label }}
      </div>
    </div>
    <ListFiltersRowItemTabs 
            :items="tabsItem.tabsOptions"
            :value="filterParams[tabsItem.prop]" 
            :attrs="tabsItem.attrs"
            @input="(v) => handleInput(v, tabsItem)"
        >
    </ListFiltersRowItemTabs>
  </div>
</template>

<script>
import { deepClone } from '@/print/components/PrintProfessional/print_util'
import ListFiltersRowItemTabs from "@/components/listFiltersRowItemTabs/index.vue";
import { queryBaseItemDisplay } from '@/servers/base/display/index'


export default {
   components: {
        ListFiltersRowItemTabs
   },
   props: {
    supplierCompanyId: [Number, String]
  },
  data() {
    return {
      filterParams: {
        newPutTime: null,
        displayCode:[],
      },
      dayOptions: [
        {
          label: '全部',
          value: null,
        },
        {
          label: '近7天',
          value: 7,
        },
        {
          label: '近30天',
          value: 30,
        },
       ],
        tabsItem: {
            prop: 'displayCode',
            attrs: { label: "展架分类" },
            tabsOptions: [],
        }
    };
  },
  methods: {
    chooseFilter(item) {
      this.filterParams.newPutTime = item.value;
        this.$emit('updateFilterParams', {
            ...this.filterParams,
            newPutTime: item.value,
        });
      this.$emit('search');
    },
    handleInput (value, handleInput = {}) {
        const { prop } = handleInput;
        this.filterParams[prop] = value;
        this.$emit('updateFilterParams', {
            ...this.filterParams,
            [prop]: value,
        });
        this.$emit('search');
    },
    getFilterParams () {
        let result = {
            ...this.filterParams,
        };
        return result;
      },
      formatBaseItemDisplayList (baseItemDisplayList = []) {
            let newList = [], list = deepClone(baseItemDisplayList);
            list.forEach(item => {
                const info = {
                    value: item.code,
                    label: item.name,
                    children: [],
                };
                if (item.list && Array.isArray(item.list)) {
                    info.children = item.list.map((el) => ({
                        value: `${item.code},${el.code}` ,
                        label: el.name,
                        children: null
                    }))
                }
                newList.push(info);
            });
            return newList;
      },
    queryDisplayRackClassifyList () {
        const params = {
            companyId: this.supplierCompanyId,
        }
        queryBaseItemDisplay(params).then(res => {
            if (res) {
                this.tabsItem.tabsOptions = this.formatBaseItemDisplayList(res);
            }
        })
      }, 
    },
    watch: {
        supplierCompanyId: {
            handler (id) {
                id && this.queryDisplayRackClassifyList();
            },
            immediate: true
        },
    },
}

</script>

<style lang='scss' scoped>
.filter {
  
}
</style>
